import { render, staticRenderFns } from "./fornecedor-painel.vue?vue&type=template&id=0559ee6e"
import script from "./fornecedor-painel.vue?vue&type=script&lang=js"
export * from "./fornecedor-painel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports